import React from 'react';
import _ from 'underscore';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withFooter } from '@bingads-webui-campaign-react/content-footer-hoc';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withCampaignType } from '@bingads-webui-campaign-react/with-campaign-type';
import { withScope } from '@bingads-webui-react/scope-service';
import { lazyLoad, withContexts, importAfterPreLoad, importAfterPreLoadHighCharts, getDefaultExport } from './utils';
import { withDFMReady } from '../data-fetch/with-dfm';

const OverviewPageNoRjsShell = () => importAfterPreLoadHighCharts(() => import(/* webpackChunkName: "overview-page" */'../feature-bootstrap/overview-page').then(getDefaultExport));
const NewOverviewPageNoRjsShell = () => importAfterPreLoadHighCharts(() => import(/* webpackChunkName: "new-overview-page" */'../feature-bootstrap/new-overview-page').then(getDefaultExport));
const NewOverviewPagePhase2NoRjsShell = () => importAfterPreLoadHighCharts(() => import(/* webpackChunkName: "new-overview-page-phase-2" */'../feature-bootstrap/new-overview-page-phase-2').then(getDefaultExport));
const CampaignsPageNoRjsShell = () => importAfterPreLoadHighCharts(() => import(/* webpackChunkName: "campaigns-page" */'../feature-bootstrap/campaigns-page').then(getDefaultExport));
const PerformancePageNoRjsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "performance-page" */'../feature-bootstrap/performance-page').then(getDefaultExport), true, true);
const AdExtensionsShellNoRjs = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "ad-extensions-page" */'../feature-bootstrap/ad-extensions-page').then(getDefaultExport), false, true);

const importAdExtensionsFeatures = () => import(/* webpackChunkName: "ad-extensions-page" */ '../feature-bootstrap/ad-extensions-dynamic');

const AdExtensionShellWrapper = React.memo((props) => {
  const Loader = lazyLoad(
    AdExtensionsShellNoRjs,
    c => importAdExtensionsFeatures().then(({ withDynamicFeatures }) => withInstrumentation(withContexts(withServerContext(withDynamicFeatures(c)))))
  );

  return (<Loader {...props} />);
});

const OverviewShellWrapper = withCampaignType(withServerContext((props) => {
  const { serverContext, campaignType, scope } = props;
  const aid = _.get(scope, ['values', 'aid']);
  const isAccountIdAvailable = !!aid;
  const {
    OverviewPageFluentV2,
    OverviewPageFluent2,
    AppAdsCampaignPhaseOne,
    LinkedInCampaigns,
    PMaxLiteOverviewFluent,
    PMaxCampaignOverviewFluent,
    CustomerLevelOverviewFluent,
    UnifiedAppAds,
  } = serverContext.DynamicPermissions;

  const isLinkedInCampaign = campaignType === 'LinkedIn' && LinkedInCampaigns;
  const overviewFluentV2 = OverviewPageFluentV2 || OverviewPageFluent2;
  const pmaxCampaignNewFluent = overviewFluentV2 && (PMaxLiteOverviewFluent || PMaxCampaignOverviewFluent);

  const showNewOverview = (
    (overviewFluentV2 || isLinkedInCampaign || AppAdsCampaignPhaseOne || pmaxCampaignNewFluent || UnifiedAppAds) && isAccountIdAvailable
  ) || CustomerLevelOverviewFluent;

  const OverviewPageNoRjsShellToUse = showNewOverview ? NewOverviewPagePhase2NoRjsShell : OverviewPageNoRjsShell;

  const Loader = lazyLoad(
    campaignType === 'PerformanceMax' && !pmaxCampaignNewFluent
      ? NewOverviewPageNoRjsShell
      : OverviewPageNoRjsShellToUse,
    c => withFooter(withContexts(c))
  );


  return (<Loader {...props} />);
}));

const CampaignsShellWrapper = React.memo((props) => {
  const Loader = lazyLoad(CampaignsPageNoRjsShell, c => withContexts(withServerContext(c)));

  return (<Loader {...props} />);
});

const PerformanceShellWrapper = (props) => {
  const Loader = lazyLoad(PerformancePageNoRjsShell, c => withContexts(withServerContext(c)));

  return (<Loader {...props} />);
};

export const adExtensionsLoader = withPermissions(AdExtensionShellWrapper);
export const overviewPageLoader = withDFMReady(withPermissions(withScope(OverviewShellWrapper)));
export const campaignsPageLoader = withPermissions(CampaignsShellWrapper);
export const performancePageLoader = withDFMReady(withPermissions(PerformanceShellWrapper));
